export default __webpack_public_path__ + "static/media/trapezoid.83f53bf7.svg";